import { FrmTextFieldWithHoverHelp } from "components/formFields/FrmTextFieldWithHoverHelp";

import { i18n } from "services/i18nService";

export function BigCommerceConnectionFields(props) {
  const { record, handleInputFieldChange, isInError } = props;

  return (
    <>
      <FrmTextFieldWithHoverHelp
        name="authorizationField1"
        value={record.authorizationField1}
        label={i18n("frmLabel.BigCommerceClientId")}
        onValueBlur={handleInputFieldChange}
        helpText={i18n("hoverHelp.cart.followInstructions")}
        error={isInError("authorizationField1")}
      />
      <FrmTextFieldWithHoverHelp
        name="authorizationField2"
        value={record.authorizationField2}
        label={i18n("frmLabel.BigCommerceAccessToken")}
        onValueBlur={handleInputFieldChange}
        helpText={i18n("hoverHelp.cart.followInstructions")}
        error={isInError("authorizationField2")}
      />
      <FrmTextFieldWithHoverHelp
        name="storeIdentifier"
        value={record.storeIdentifier}
        label={i18n("frmLabel.BigCommerceApiPath")}
        onValueBlur={handleInputFieldChange}
        helpText={i18n("hoverHelp.cart.followInstructions")}
        error={isInError("storeIdentifier")}
      />
    </>
  );
}
